const e={number:/^[0-9]$/,text:/^[a-zA-Z0-9]$/,hexadecimal:/^[a-fA-F0-9]$/,"text-only":/^[a-zA-Z]$/},t=Object.fromEntries(Object.entries(e).map((([e,t])=>[e,new RegExp(t.source.replace("$","+$"))])));export{t as codeRegex,e as codeRegexKey};
//# sourceMappingURL=utils.js.map
